import { HttpClient } from '@angular/common/http';
import {
    Component,
    HostBinding,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { SnackbarService } from '@app/services/snackbar.service';
import { AuthService } from '@auth0/auth0-angular';
import * as moment from 'moment';
import { interval } from 'rxjs/internal/observable/interval';


@Component({
    selector: 'syn-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    @HostBinding('class') routerClass = '/';

    isLoading$;

    private CHECK_VERSION_URL = 'assets/version.json';
    private CHECK_VERSION_DELAY = 60; // in seconds
    private currentVersion: string;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private httpClient: HttpClient,
        private snackbarService: SnackbarService,
        private authService: AuthService
    ) {
        // set synapps icons pack
        this.matIconRegistry.registerFontClassAlias(
            'synapps',
            'synapps-icons'
        );

        // Set date format to french
        moment.locale('fr');

        this.isLoading$ = this.authService.isLoading$;
    }

    async ngOnInit(): Promise<void> {
        // check version when booting application
        this.checkVersion();
        // check version every X seconds
        interval(this.CHECK_VERSION_DELAY * 1000)
            .subscribe(() => this.checkVersion());
    }

    private checkVersion() {
        this.httpClient.get(this.CHECK_VERSION_URL + '?t=' + new Date().getTime())
            .subscribe(
                (response: { version: string }) => {
                    if (this.currentVersion && this.currentVersion !== response.version) {
                        this.snackbarService.show({
                            message: 'L\'application a été mise à jour, la page va se recharger dans quelques secondes.',
                            type: 'info',
                            timeout: 5000
                        });
                        setTimeout(() => {
                            location.reload();
                        }, 5000);
                    }
                    this.currentVersion = response.version;
                },
                (err) => {
                    console.error(err, 'Could not get version');
                }
            );
    }

}
